<template>
  <div>
    <div class="container">
      <p id="dashboardItemTitle">Profile</p>
      <div class="card">
        <div class="card-content">
          <div class="content">
            <section>

              <b-field
                  horizontal
                  :type="invalidName == '' ? '' : 'is-danger'"
                  :message="invalidName">
                <template slot="label">Name <span class="has-text-danger">*</span></template>
                <b-input @input="resetInvalidStatus('invalidName')" v-model="formData.name"  expanded></b-input>
              </b-field>

              <b-field
                  horizontal
                  :type="invalidUsername == '' ? '' : 'is-danger'"
                  :message="invalidUsername">
                <template slot="label">Username <span class="has-text-danger">*</span></template>
                <b-input disabled @input="resetInvalidStatus('invalidUsername')" v-model="formData.username"  expanded></b-input>
              </b-field>


              <b-field
                  horizontal
                  :type="invalidEmail == '' ? '' : 'is-danger'"
                  :message="invalidEmail">
                <template slot="label">Email <span class="has-text-danger">*</span></template>
                <b-input @input="resetInvalidStatus('invalidEmail')" v-model="formData.email" expanded></b-input>
              </b-field>

              <b-field
                  horizontal>
                <template slot="label">Contact No <span class="has-text-danger">*</span></template>
                <b-field grouped
                         :type="invalidContact == '' ? '' : 'is-danger'"
                         :message="invalidContact">
                  <b-input @input="resetInvalidStatus('invalidContact')" v-model="formData.contact" ></b-input>
                </b-field>
              </b-field>

              <b-field
                  horizontal>
                <template slot="label">NIC <span class="has-text-danger">*</span></template>
                <b-field grouped
                         :type="invalidNIC == '' ? '' : 'is-danger'"
                         :message="invalidNIC">
                  <b-input @input="resetInvalidStatus('invalidNIC')" v-model="formData.nic" ></b-input>
                </b-field>
              </b-field>

              <b-field
                  horizontal>
                <template slot="label">Change Password</template>
                <b-field grouped >
                    <div class="block">
                      <b-radio v-model="formData.changepassword"
                               @input="checkSelectedValue()"
                               name="isPasswordChange"
                               native-value="yes">
                       Yes
                      </b-radio>
                      <b-radio v-model="formData.changepassword"
                               @input="checkSelectedValue()"
                               name="isPasswordChange"
                               native-value="no">
                        No
                      </b-radio>
                    </div>
                 </b-field>
              </b-field>

              <div v-if="showPasswordInputs">
                <b-field
                    horizontal>
                  <template slot="label">Current Password <span class="has-text-danger">*</span></template>
                  <b-field grouped
                           :type="invalidCurrentPassword == '' ? '' : 'is-danger'"
                           :message="invalidCurrentPassword">
                    <b-input @input="resetInvalidStatus('invalidCurrentPassword')" v-model="formData.currentPassword" ></b-input>
                  </b-field>
                </b-field>


                <b-field
                    horizontal>
                  <template slot="label">New Password <span class="has-text-danger">*</span></template>
                  <b-field grouped
                           :type="invalidNewPassword == '' ? '' : 'is-danger'"
                           :message="invalidNewPassword">
                    <b-input @input="resetInvalidStatus('invalidNewPassword')" v-model="formData.newPassword" ></b-input>
                  </b-field>
                </b-field>
              </div>

              <b-field horizontal>
                <div class="block"></div>
              </b-field>

              <div class="tile custom-tile-narrow">
                <div class="column">
                  <div class="columns">
                    <div class="column">
                      <p class="has-text-danger is-italic">Fields marked with <big>*</big> are mandatory</p>
                    </div>
                    <div class="buttons">
                      <b-button  :loading="formIsSubmitting" type="is-success" @click="validateAndSubmit()">Save</b-button>
                      <b-button @click="$navigate(-1)"  type="is-danger">Cancel</b-button>
                    </div>
                  </div>
                </div>
              </div>

            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name:'profile-view',

  data(){
    return{
      formData:{
        name:'',
        username: '',
        email: '',
        contact: '',
        nic:'',
        role: null,
        password: '',
        selectedPermissions: [],
        disabled: 0,
        department:null,
        changepassword:'no',
        currentPassword:'',
        newPassword:''
      },

      formIsSubmitting:false,

      formIsInvalid: false,
      invalidName: '',
      invalidUsername: '',
      invalidEmail: '',
      invalidContact: '',
      invalidRole: '',
      invalidPassword: '',
      invalidNIC:'',
      invalidDepartment:'',
      invalidCurrentPassword:'',
      invalidNewPassword:'',

      showPasswordInputs:false,

      regex:{
        name: /^[a-zA-Z][a-zA-Z ]+$/,
        last_name: /^[a-zA-Z][a-zA-Z ]+$/,
        userName: /^[a-zA-Z0-9._]+$/,
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        contact: /^[0-9]{10}$/,
        nic:/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/
      },
    }
  },

  methods:{

    checkSelectedValue: function (){
       if(this.formData.changepassword == 'yes'){
         this.showPasswordInputs = true
       }else{
         this.showPasswordInputs = false
       }
    },

    validateForm: function(){
      var formIsValid = true

      // first name
      if(this.formData.name=='' || this.formData.name.indexOf(' ') >= 0){
        this.invalidName = 'This field cannot left blank'
        formIsValid = false
      }
      else if(!this.regex.name.test(this.formData.name)){
        this.invalidName = 'Name cannot contain numbers or special characters'
        formIsValid = false
      }


      // email
      if(this.formData.email=='' || this.formData.email.indexOf(' ') >= 0){
        this.invalidEmail = 'This field cannot left blank'
        formIsValid = false
      }
      else if(!this.regex.email.test(this.formData.email)){
        this.invalidEmail = 'Please enter a valid email'
        formIsValid = false
      }


      // contact
      if(this.formData.contact=='' || this.formData.contact.indexOf(' ') >= 0){
        this.invalidContact = 'This field cannot left blank'
        formIsValid = false
      }
      else if(!this.regex.contact.test(this.formData.contact)){
        this.invalidContact = 'Please enter a valid contact number'
        formIsValid = false
      }else{
        //validate mobile number
        var getDigits = this.formData.contact.substr(1,1)
        var inputNumber = [];
        inputNumber.push(getDigits);
        var Digits = ["9","8","6","5","4","3","2","1","0"]

        const match =inputNumber.filter(element => Digits.includes(element));

        if(match.length > 0){

          this.invalidContact = 'Please enter a valid contact number'
          formIsValid = false
        }
      }

      // NIC
      if(this.formData.nic=='' || this.formData.nic.indexOf(' ') >= 0){
        this.invalidNIC = 'This field cannot left blank'
        formIsValid = false
      }
      else if(!this.regex.nic.test(this.formData.nic)){
        this.invalidNIC = 'Please enter a valid NIC number'
        formIsValid = false
      }



      // password

      if(this.showPasswordInputs == true){
        if(this.formData.currentPassword ==''){
          this.invalidCurrentPassword = 'This field cannot left blank'
          formIsValid = false
        }
        else if(this.formData.currentPassword.indexOf(' ') >= 0){
          this.invalidCurrentPassword = 'This field cannot contain white spaces'
          formIsValid = false
        }
        else if(this.formData.currentPassword.length < 8){
          this.invalidCurrentPassword = 'Password must contain at least 8 characters'
          formIsValid = false
        }


        if(this.formData.newPassword==''){
          this.invalidNewPassword = 'This field cannot left blank'
          formIsValid = false
        }
        else if(this.formData.newPassword.indexOf(' ') >= 0){
          this.invalidNewPassword = 'This field cannot contain white spaces'
          formIsValid = false
        }
        else if(this.formData.newPassword.length < 8){
          this.invalidNewPassword = 'Password must contain at least 8 characters'
          formIsValid = false
        }
      }



      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false

    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },

    submitForm:function (){
      var component = this
      component.formIsSubmitting = true
      axios.post(component.$base_url+'/agent/UpdateProfileDetails', {
        auth_token:component.$root.agentAuthToken,
        user_id:component.$root.user_id,
        name:component.formData.name,
        email:component.formData.email,
        nic:component.formData.nic,
        contact:component.formData.contact,
        is_passwordChange:component.formData.changepassword,
        current_password:component.formData.currentPassword,
        new_password:component.formData.newPassword,
      })
          .then(function (response) {
            component.formIsSubmitting = false
            console.log(response.data.message)
            if(response.data.success == true){
              component.showPasswordInputs = false
              component.formData.currentPassword = ''
              component.formData.newPassword = ''
              component.$buefy.toast.open({
                message: response.data.message,
                type: 'is-success'
              })
            }

            if(response.data.success == false){
              component.$buefy.toast.open({
                message: response.data.message,
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });
    },

    getProfileData:function (){
      var comp = this

      try {
        axios.post(comp.$base_url + '/agent/getProfileData', {
          user_id: comp.$root.user_id,
          auth_token:comp.$root.agentAuthToken
        })
            .then(function (response) {
              console.log("get profile data---------------")
              console.log(response)
              if (response.data.success) {

                var originalrecord = []
                originalrecord = response.data.data

                comp.formData.name      = originalrecord.name
                comp.formData.email     = originalrecord.email
                comp.formData.contact   = originalrecord.contact_number
                comp.formData.nic       = originalrecord.id_number
                comp.formData.username  = originalrecord.username

              } else {
                comp.$buefy.toast.open({
                  message: "Failed to fetch data",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to fetch data",
                type: "is-danger",
              });
            });

      } catch (e) {
        comp.$buefy.toast.open({
          message: e,
          type: "is-danger",
        });
        console.log("Exception occurred in Customer Template List getTemplateList() : " + e.message)
      }
    }

  },

  mounted() {
    this.getProfileData()
  }

}
</script>
